import { Helmet } from "react-helmet-async";

export const SEOHead = ({ 
  title = "Global Data XM | Web Development, AI & Workflow Solutions",
  description = "Custom Digital Solutions for Modern Businesses. Web Development, AI Solutions, Workflow Apps and Marketing Technology designed to help companies scale faster.",
  image = "https://customer-assets.emergentagent.com/job_7f4a87ba-537f-4b54-bc71-c609bc6c0086/artifacts/t0ktnmdv_AC0727BB-0004-4C61-92B6-8EDA06A616D5.png",
  url = ""
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEOHead;
